import { render, staticRenderFns } from "./vip-msg.vue?vue&type=template&id=8dd7b0ee&scoped=true&"
import script from "./vip-msg.vue?vue&type=script&lang=js&"
export * from "./vip-msg.vue?vue&type=script&lang=js&"
import style0 from "./vip-msg.vue?vue&type=style&index=0&id=8dd7b0ee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dd7b0ee",
  null
  
)

export default component.exports